import { render } from "./Clientes.vue?vue&type=template&id=1d0f5e9a"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__